export const UPLOAD_BUCKET = __BLUEHQ_UPLOAD_BUCKET__;
export const IAM_ROLE = 'arn:aws:iam::043214960131:role/bluehq-dev-access-to-s3-per-user';
export const IAM_PROVIDER = 'arn:aws:iam::043214960131:saml-provider/auth0-provider';
